let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2Oeyl")).then(() => parcelRequire('dHjlh'));